export default class {
  constructor(object) {
    for (const key in object) {
      this[key] = object[key]
    }
  }
}
